let expressTemplates = [
    {
        url: "impulse",
        title: "Impulse",
        description: [
            "Modern și dinamic, Impulse a fost creat pentru a pune în evidență cele mai importante elemente ale brandului tău. Un aspect simplu și aerisit, cu imagini mari, cu siguranță va impulsiona clienții să-ți aprecieze și cumpere produsele.",
            "Acest magazin vine echipat din start cu Formular de abonare la newsletter, Wishlist și Modul de preview produse",
        ],
        bullets: [
            "Design aerisit, minimalist, intuitiv",
            "Ideal pentru Produse de Fashion&Accesorii, Home&Deco, Cosmetice, Copii & Bebe",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro65a/",
        images: [
            "impulse/thumb.jpg",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "dream",
        title: "Dream",
        description: [
            "Dream este un magazin cu un design plin de energie, potrivit pentru o gamă largă de produse: Jucării, Accesorii, Produse de îngrijire, Decorațiuni. Structura dinamică a designului îți permite să oferi o prezentare amplă a produselor.",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse",
        ],
        bullets: [
            "Design dinamic, modern",
            "Ideal pentru Jucării, Accesorii, Produse cosmetice, Decorațiuni, Cadouri",
        ],
        demoUrl: null,
        images: [
            "dream/thumb.jpg",

        ],
        categories: [
            "kids"
        ]
    },
    {
        url: "explore",
        title: "Explore",
        description: [
            "Perfect pentru industria Automoto, designul Explore vine pregătit cu toate funcționalitățile de care ai nevoie pentru a-ți impresiona clienții încă de la prima vizită. Designul optimizat pentru orice dispozitiv, te aduce mai aproape de clienții tăi indiferent de ce device folosesc.",
            "Acest magazin vine echipat din start cu Formular de abonare la newsletter, Blog, Modul de review produse",
        ],
        bullets: [
            "Design intuitiv, dinamic, modern",
            "Ideal pentru Auto & Moto, Scule și Echipamente",
        ],
        demoUrl: null,
        images: [
            "explore/thumb.png",

        ],
        categories: [
            "auto"
        ]
    },
    {
        url: "play",
        title: "Play",
        description: [
            "Magazinul online Play pune accent pe simplitate și funcționalități eficiente. A fost conceput special pentru magazinele online cu o ofertă generoasă de produse, fiind optimizat pentru orice dispozitiv",
            "Acest magazin vine echipat din start cu Formular de abonare la newsletter, Modul de review produse, Modul comparare produse ",
        ],
        bullets: [
            "Design simplu, modern, intuitiv ",
            "Ideal Copii & Bebe, Jucării, Home&Deco, Electronice & Electrocasnice",
        ],
        demoUrl: null,
        images: [
            "play/thumb.png",

        ],
        categories: [
            "kids"
        ]
    },
    {
        url: "elite",
        title: "Elite",
        description: [
            "Elite va atrage atenția clienților tăi instantaneu, pentru că produsele tale sunt prezentate prin imagini mari, în cea mai bună lumină. Fiecare detaliu, de la butoane până la filtre a fost gândit pentru a comunica valorile afacerii tale, prin eleganță și simplitate.",
            "Acest magazin vine echipat din start cu Wishlist, Pagina de meniu, Galerie și Formular Rezervare.",
        ],
        bullets: [
            "Design minimalist și elegant, care se folosește de imagini pentru a-și transmite mesajul",
            "Ideal pentru Produse Food & Drinks, Horeca",
        ],
        demoUrl: null,
        images: [
            "elite/thumb.png",

        ],
        categories: [
            "fooddrinks"
        ]
    },
    {
        url: "star",
        title: "Star",
        description: [
            "Eleganța vine din simplitate. Star este un design minimalist, care scoate în evidență fiecare detaliu și este ușor de personalizat. Alegerea perfectă pentru magazinele de bijuterii, accesorii sau produse fashion. ",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse. ",
        ],
        bullets: [
            "Design minimalist și elegant",
            "Ideal pentru Magazine de Bijuterii & Accesoriii, Fashion",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro62a/",
        images: [
            "star/thumb.png",

        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "zain",
        title: "Zain",
        description: [
            "Am proiectat un magazin online, cu un design minimalist și modern, care să pună în valoare calitatea produselor tale. Designul aerisit, cu imagini mari, e perfect pentru proiecte de fashion, home&deco sau magazine cu produse pentru mămici și copii.",
            "Acest magazin vine echipat din start cu Blog, Galerie, Wishlist și Formular de abonare la newsletter",
        ],
        bullets: [
            "Design minimalist și aerisit",
            "Ideal pentru Magazine de Home & Deco, Accesorii, Bijuterii, Copii&Bebe, Fashion",
        ],
        demoUrl: null,
        images: [
            "zain/thumb.png",

        ],
        categories: [
            "homedeco"
        ]
    },
    {
        url: "zip",
        title: "Zip",
        description: [
            "Zip a fost conceput special pentru magazinele online cu o ofertă generoasă de produse. Cu un design energic și intuitiv, oferă clienților tăi experiența cumpărăturilor online în ton cu cele mai noi trenduri.",
            "Acest magazin vine echipat din start cu Wishlist, Modul comparare produse și Formular de abonare la newsletter",
        ],
        bullets: [
            "Design minimalist și aerisit",
            "Ideal pentru Produse Cosmetice, Home & Deco, Accesorii, Bijuterii",
        ],
        demoUrl: "https://s4s.blugento.ro/csro64a/",
        images: [
            "zip/thumb.png",
        ],
        categories: [
            "fashion",
            "cosmetics"
        ]
    },
    {
        url: "space",
        title: "Space",
        description: [
            "Designerii noștri au proiectat un concept de magazin online, pliat perfect pe nevoile companiei tale. Simplu și aerisit, interfață intuitivă și design responsive, experiența de shopping online va fi una foarte plăcută.",
            "Acest magazin vine echipat din start cu Blog, Formular de abonare la newsletter și Modul de preview produse",
        ],
        bullets: [
            "Design minimalist și aerisit",
            "Ideal pentru Magazine de Home & Deco, Accesorii, Bijuterii, Copii & Bebe, Fashion",
        ],
        demoUrl: null,
        images: [
            "space/thumb.png",
        ],
        categories: [
            "fashion",
            "cosmetics"
        ]
    },
    {
        url: "queen",
        title: "Queen",
        description: [
            "Queen este un magazin online fresh, cu un design aerisit și modern, care va cuceri inima clienților tăi. Cu o gamă largă de funcționalități și interfață intuitivă, este perfect pentru proiecte de Fashion, Home&Deco, Accesorii, Turism.",
            "Acest magazin vine echipat din start cu Blog, Formular de abonare la newsletter și Modul de preview produse",
        ],
        bullets: [
            "Design fresh, aerisit, intuitiv",
            "Ideal pentru Produse de Fashion, Home & Deco, Cosmetice, Copii & Bebe",
        ],
        demoUrl: null,
        images: [
            "queen/thumb.png",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "brandy",
        title: "Brandy",
        description: [
            "Brandy va atrage atenția clienților tăi printr-un design robust, dinamic și modern. Imaginile de calitate și designul intuitiv, denotă încredere și profesionalism iar experiența cumpărăturilor online va fi excelentă.",
            "Acest magazin vine echipat din start cu Formular de abonare la newsletter, Wishlist și Modul de preview produse",
        ],
        bullets: [
            "Design minimalist și aerisit",
            "Ideal pentru Produse Food & Drinks, Fashion, Beauty",
        ],
        demoUrl: "https://s4s.blugento.ro/fdro60a/",
        images: [
            "brandy/thumb.png",
        ],
        categories: [
            "fooddrinks"
        ]
    },
    {
        url: "blanc",
        title: "Blanc",
        description: [
            "Precum un design scandinav, Blanc impresionează prin simplitate, minimalism, și elemente vizuale puternice. Interfața intuitivă oferă vizitatorilor experiența cumpărăturilor online în ton cu cele mai noi trenduri din industrie.",
            "Acest magazin vine echipat din start cu Blog, Formular de abonare la newsletter și Modul de preview produse",
        ],
        bullets: [
            "Design fresh, aerisit, intuitiv",
            "Ideal pentru Produse de Home & Deco, Fashion & Accesorii, Cosmetice, Copii & Bebe",
        ],
        demoUrl: null,
        images: [
            "blanc/thumb.png",
        ],
        categories: [
            "homedeco"
        ]
    },
    {
        url: "karv",
        title: "Karv",
        description: [
            "Karv impresionează prin elemente vizuale puternice și simpliste puse în evidență de un design minimalist. Interfața intuitivă oferă vizitatorilor experiența cumpărăturilor online în ton cu cele mai noi trenduri din industrie.",
            "Acest magazin vine echipat din start cu Formular de abonare la newsletter, Wishlist și Modul de preview produse",
        ],
        bullets: [
            "Design aerisit, minimalist, intuitiv",
            "Ideal pentru Produse de Fashion & Accesorii, Home & Deco, Cosmetice, Copii & Bebe",
        ],
        demoUrl: null,
        images: [
            "karv/thumb.jpg",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "deluxe",
        title: "Deluxe",
        description: [
            "Deluxe este un magazin online atractiv, robust, care oferă un spațiu generos pentru afișarea imaginilor cu care îți poți convinge clienții foarte rapid. Cu o gamă largă de funcționalități și interfață intuitivă, este perfect pentru proiecte de Fashion, Home&Deco, Turism.",
            "Acest magazin vine echipat din start cu Formular de abonare la newsletter, Blog, Modul de review produse",
        ],
        bullets: [
            "Design atractiv, modern, cu imagini mari",
            "Ideal pentru Fashion, Home & Deco, Turism, Copii & Bebe",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro66a/",
        images: [
            "deluxe/thumb.png",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "cult",
        title: "Cult",
        description: [
            "Vibrant și dinamic, designul Cult promite că va surprinde vizitatorii magazinului tău online prin fiecare detaliu. Interfața intuitivă oferă acestora experiența cumpărăturilor online în ton cu cele mai noi trenduri.",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Blog.",
        ],
        bullets: [
            "Design dinamic, modern, cu interfață intuitivă",
            "Ideal pentru Accesorii, Home & Deco, Fashion, Cosmetice",
        ],
        demoUrl: null,
        images: [
            "cult/thumb.png",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "berry",
        title: "Berry",
        description: [
            "Am creat un magazin online cu un design minimalist, dar în același timp dinamic și variat. Berry are un aspect aerisit, iar jocul de imagini mici și mari, e perfect pentru magazine cu articole pentru copii și mămici, sau proiecte de fashion și home & deco.",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Blog.",
        ],
        bullets: [
            "Design minimalist, aerisit, dinamic",
            "Ideal pentru Produse pentru Copii & Bebe, Jucării, Fashion, Produse Bio",
        ],
        demoUrl: null,
        images: [
            "berry/thumb.png",
        ],
        categories: [
            "fashion",
            "kids"
        ]
    },
    {
        url: "city",
        title: "City",
        description: [
            "City îmbină armonios clasicul cu modernul și e perfect pentru afacerile care activează în domeniul Horeca și care au prezență și în mediul offline. Fie că ai cafenea, bar sau restarant, acest design va cuceri inima clienților tăi.",
            "Acest magazin vine echipat din start cu Wishlist, Pagina de meniu, Galerie și Formular Rezervare.",
        ],
        bullets: [
            "Design elegant și atractiv",
            "Ideal pentru Produse HORECA",
        ],
        demoUrl: "https://s4s.blugento.ro/fdro54a/",
        images: [
            "city/thumb.png",
        ],
        categories: [
            "fooddrinks"
        ]
    },
    {
        url: "zoom",
        title: "Zoom",
        description: [
            "Știm că produsele complexe au nevoie de un design minimal, care să scoată în evidență fiecare detaliu. De aceea, am creat Zoom, un design care așează produsele tale în lumina reflectoarelor.",
            "Zoom vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Interfață intuitivă și design minimal",
            "Ideal pentru Produse Fashion, Accesorii",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro22a/",
        images: [
            "zoom/thumb.jpg",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "vivo",
        title: "Vivo",
        description: [
            "Vivo este un magazin cu un design plin de energie, potrivit pentru o gamă largă de produse. Vivo este design-ul care îmbină armonios clasicul cu modernul și care va face impresie bună clienților tăi.",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de comparare produse.",
        ],
        bullets: [
            "Design elegant și atractiv",
            "Ideal pentru Produse Home & Deco",
        ],
        demoUrl: "https://s4s.blugento.ro/hdro22a/",
        images: [
            "vivo/thumb.jpg",
        ],
        categories: [
            "homedeco"
        ]
    },
    {
        url: "classy",
        title: "Classy",
        description: [
            "Am conceput un magazin online, cu un design minimalist și modern, care să pună în evidență calitatea produselor tale. Designul aerisit, cu imagini mari, e perfect pentru proiecte de fashion, home&deco sau magazine cu produse pentru mămici și copii.",
            "Classy vine echipat din start cu Wishlist, Formular de abonare la newsletter, Blog, Modul de review produse.",
        ],
        bullets: [
            "Design simplu, minimalist",
            "Ideal pentru Produse Fashion, Baby, Handmade, Home & Deco",
        ],
        demoUrl: "https://s4s.blugento.ro/hdro22a/",
        images: [
            "classy/thumb.png",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "idea",
        title: "Idea",
        description: [
            "Magazinul online Idea are un design puternic, creat având în minte nevoile unui business cu produse tehnice. Perfect pentru verticalele Scule & Echipamente sau Auto & Moto și inclusiv pentru magazine multi-brand.",
            "Idea vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse, Modul comparare produse.",
        ],
        bullets: [
            "Design atractiv, modern",
            "Ideal pentru Scule & Echipamente, Auto & Moto",
        ],
        demoUrl: "https://s4s.blugento.ro/tero56a/",
        images: [
            "idea/thumb.png",
        ],
        categories: [
            "tools"
        ]
    },
    {
        url: "living-ii",
        title: "Living",
        description: [
            "Magazinul online Living a fost conceput special pentru magazinele online cu o ofertă generoasă de produse. Perfect pentru verticalele Electronice&Electrocasnice, Scule & Echipamente și Auto & Moto.",
            "Living vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse, Modul comparare produse.",
        ],
        bullets: [
            "Design atractiv, modern",
            "Ideal pentru Electronice & Electrocasnice și Auto & Moto",
        ],
        demoUrl: "https://s4s.blugento.ro/elro52a/",
        images: [
            "living/thumb.png",
        ],
        categories: [
            "itc"
        ]
    },
    {
        url: "book-store",
        title: "Book Store",
        description: [
            "Book Store are un design care se va potrivi perfect nevoilor magazinului tău. Cu accente minimale și cu o interfață dinamică și intuitivă, acest design pune în valoare orice carte sau produse de papetărie și birotică.",
            "Acest magazin vine echipat din start cu Wishlist, Pagina de meniu, Galerie și Formular Rezervare.",
        ],
        bullets: [
            "Design minimalist și interfață intuitivă",
            "Ideal pentru produse de birotică și paptărie, cărți",
        ],
        demoUrl: "https://s4s.blugento.ro/otro61a/",
        images: [
            "bookstore/thumb.png",
        ],
        categories: [
            "others"
        ]
    },
    {
        url: "shopper",
        title: "Shopper",
        description: [
            "Shopper a fost creat pentru a a scoate în evidență cele mai importante elemente ale brandului tău. Design-ul puternic, dar totodată aerisit, cu imagini mari, îl face foarte potrivit pentru proiecte de fashion&accesorii, home & deco.",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design aerisit, puternic, intuitiv",
            "Ideal pentru produse de Fashion & Accesorii, Home & Deco",
        ],
        demoUrl: null,
        images: [
            "shopper/thumb.png",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "air",
        title: "Air",
        description: [
            "Acest design oferă aspectul unei reviste de Home&Deco. Imaginile mari și design-ul minimalist vor acapara atenția clienților tăi asupra categoriilor de produs propuse de tine.",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design minimalist și modern",
            "Ideal pentru produse Home & Deco, Industrii creative",
        ],
        demoUrl: null,
        images: [
            "air/thumb.png",
        ],
        categories: [
            "homedeco"
        ]
    },
    {
        url: "apparel",
        title: "Apparel",
        description: [
            "Magazinul online Apparel are un aspect modern, cu un impact puternic, fiind perfect pentru orice business din industria de Fashion și Home&Deco. Cu acest design, produsele tale vor fi sub lumina reflectoarelor.",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design aerisit, puternic, intuitiv",
            "Ideal pentru produse de Fashion & Accesorii, Home & Deco",
        ],
        demoUrl: null,
        images: [
            "apparel/thumb.png",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "active",
        title: "Active",
        description: [
            "Cu Active, ai un magazin simplu, concis și explicit. Active este design-ul care îmbină armonios clasicul cu modernul și cu care vei câștiga rapid încrederea clienților tăi. Funcționează excelent pentru produse și accesorii pentru Grădină&Fermă, Utilaje, Bricolaje.",
            "Acest magazin vine echipat din start cu Modul de review produse, Blog, Testimoniale.",
        ],
        bullets: [
            "Design simplu, aerisit, intuitiv",
            "Ideal pentru produse de Grădină și Fermă, Utilaje, Fitosanitare, Bricolaj",
        ],
        demoUrl: null,
        images: [
            "active/thumb.png",
        ],
        categories: [
            "tools"
        ]
    },
    {
        url: "viva",
        title: "Viva",
        description: [
            "Viva a fost creat pentru a da un aer natural și plăcut imaginii brand-ului tău prin simplitate, culoare și imagini. Design-ul atractiv și varietățile de funcționalități devin elementele complementare afacerii tale.",
            "Acest magazin vine echipat din start cu Formular de abonare la newsletter, Modul de review produse, Wishlist.",
        ],
        bullets: [
            "Design atractiv și intuitiv",
            "Ideal pentru produse Bio, Farmaceutice, Naturiste",
        ],
        demoUrl: null,
        images: [
            "viva/thumb.png",
        ],
        categories: [
            "fooddrinks"
        ]
    },
    {
        url: "shine",
        title: "Shine",
        description: [
            "Shine a fost creat special pentru ca produsele tale să strălucească. Strălucirea vine din simplitatea design-ului, care este totodată modern și de impact, și din gama largă de funcționalități.",
            "Acest magazin vine echipat din start cu Wishlist, Formular de abonare la newsletter, Blog.",
        ],
        bullets: [
            "Design minimalist, aerisit, cu interfață intuitivă ",
            "Ideal pentru Produse Cosmetice, Home & Deco, Accesorii, Bijuterii",
        ],
        demoUrl: "https://s4s.blugento.ro/csro63a/",
        images: [
            "shine/thumb.png",
        ],
        categories: [
            "cosmetics",
            "fashion"
        ]
    },
    {
        url: "dash",
        title: "Dash",
        description: [
            "Fiecare detaliu al magazinului tău online va surprinde vizitatorii în cele mai plăcute moduri. Indiferent de produsele pe care le comercializezi, fie că acestea sunt articole vestimentare, jucării sau accesorii baby, clienții tăi se vor bucura de aceleași performanțe, de fiecare dată.",
            "Dash vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse și Blog.",
        ],
        bullets: [
            "Design creativ și atractiv",
            "Ideal pentru Produse pentru Copii & Bebe, Jucării, Fashion",
        ],
        demoUrl: "https://s4s.blugento.ro/bpro22a/",
        images: [
            "dash/thumb.jpg",
        ],
        categories: [
            "kids"
        ]
    },
    {
        url: "electric",
        title: "Electric",
        description: [
            "Am creat un design care să se plieze perfect pe nevoile magazinului tău. Ideal pentru produse electronice, electrocasnice și gadgeturi, Electric îți oferă posibilitatea de a oferi o imagine amplă a produselor tale. Interfața intuitivă oferă vizitatorilor experiența cumpărăturilor online în ton cu cele mai noi trenduri.",
            "Electric vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review și comparare produse.",
        ],
        bullets: [
            "Design minimal",
            "Ideal pentru Produse Electrocasnice, Electronice",
        ],
        demoUrl: "https://s4s.blugento.ro/elro21a/",
        images: [
            "electric/thumb.jpg",
        ],
        categories: [
            "itc"
        ]
    },
    {
        url: "tech",
        title: "Tech",
        description: [
            "Am creat un design care să se plieze perfect pe nevoile magazinului tău. Ideal pentru produse electronice, electrocasnice și gadgeturi, Tech îți oferă posibilitatea de a oferi o imagine detaliată a produselor tale. Interfața intuitivă oferă vizitatorilor experiența cumpărăturilor online în ton cu cele mai noi trenduri.",
            "Tech vine echipat din start cu Wishlist, formular de abonare la newsletter, modul de review produse si modul de comparare produse.",
        ],
        bullets: [
            "Design minimal",
            "Ideal pentru Produse Electronice și Electrocasnice",
        ],
        demoUrl: "https://s4s.blugento.ro/elro23a/",
        images: [
            "tech/thumb.jpg",
        ],
        categories: [
            "itc"
        ]
    },
    {
        url: "glam",
        title: "Glam",
        description: [
            "Am conceput un magazin online care sa pună produsele tale în lumina reflectoarelor. Designul modern și dinamic, nu impune limitări atunci când vine vorba de creativitate, iar tu poți personaliza interfața magazinului în funcție de valorile și povestea brandului tău.",
            "Glam vine echipat din start cu Wishlist, Formular de abonare la newsletter, Blog, Modul de review produse.",
        ],
        bullets: [
            "Design bogat, memorabil",
            "Ideal pentru Produse Fashion, Cosmetice, Industrii Creative",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro03a/",
        images: [
            "glam/thumb.jpg",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "gastro",
        title: "Gastro",
        description: [
            "Imaginea din banner este cea care va atrage atenția clienților tăi. Fiecare detaliu, de la butoane până la filtre și imagini a fost gândit pentru a comunica valorile companiei tale.",
            "Gastro vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design minimalist și elegant, care se folosește de imagini pentru a-și transmite mesajul",
            "Ideal pentru Produse Food & Drinks, Horeca",
        ],
        demoUrl: "https://s4s.blugento.ro/fdro07a/",
        images: [
            "gastro/thumb.jpg",
        ],
        categories: [
            "fooddrinks"
        ]
    },
    {
        url: "tiffany",
        title: "Tiffany",
        description: [
            "Tiffany este magazinul online perfect pentru magazinele de bijuterii, accesorii sau produse fashion. Ușor de personalizat, devine într-un timp scurt, magazinul online pe care clienții tăi îl vor îndrăgi.",
            "Tiffany vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design minimalist și elegant",
            "Ideal pentru Magazine de Bijuterii & Accesoriii, Fashion",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro12a/",
        images: [
            "tiffany/thumb.jpg",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "color",
        title: "Color",
        description: [
            "Fiecare detaliu al magazinului tău online va surprinde vizitatorii în cele mai plăcute moduri. Indiferent de produsele pe care le comercializezi, fie că acestea sunt rechizite, jucării sau accesorii baby, clienții tăi se vor bucura de aceleași perfomanțe, de fiecare dată.",
            "Color vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse și Blog",
        ],
        bullets: [
            "Design energic și vioi",
            "Ideal pentru Rechizite, Produse pentru Copii",
        ],
        demoUrl: "https://s4s.blugento.ro/cbro29a/",
        images: [
            "color/thumb.jpg",
        ],
        categories: [
            "kids"
        ]
    },
    {
        url: "craft",
        title: "Craft",
        description: [
            "Industriile creative au nevoie de un design care să pună detaliile produselor sub o lumină atractivă. Am creat un design care să nu impună limitări atunci când vine vorba de creativitate. Craft este un design minimal, dinamic și cu o interfață intuitivă.",
            "Craft vine echipat din start cu Wishlist și Formular de abonare la newsletter, Modul comparare produse",
        ],
        bullets: [
            "Design minimal, interfață intuitivă",
            "Ideal pentru Industrii Creative, Hobby & Design, Fashion",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro16a/",
        images: [
            "craft/thumb.jpg",
        ],
        categories: [
            "fashion",
            "others"
        ]
    },
    {
        url: "toy",
        title: "Toy",
        description: [
            "Fiecare detaliu al magazinului tău online va surprinde vizitatorii în cele mai plăcute moduri. Indiferent de produsele pe care le comercializezi, fie că acestea sunt rechizite, jucării sau accesorii baby, clienții tăi se vor bucura de aceleași performanțe, de fiecare dată.",
            "Toy vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design minimalist și dinamic",
            "Ideal pentru Jucării și Produse pentru Copii",
        ],
        demoUrl: "https://s4s.blugento.ro/cbro35a/",
        images: [
            "toy/thumb.jpg",
        ],
        categories: [
            "kids"
        ]
    },
    {
        url: "light",
        title: "Light",
        description: [
            "Conceput pentru produse electronice și electrocasnice, Light îți oferă o gamă largă de funcționalități pentru ca tu să te bucuri de perfomanțele magazinului tău online.",
            "Light vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de comparare produse.",
        ],
        bullets: [
            "Design simplu și atractiv",
            "Ideal pentru Gadget-uri, Electronice și Electrocasnice",
        ],
        demoUrl: "https://s4s.blugento.ro/elro51a/",
        images: [
            "light/thumb.jpg",
        ],
        categories: [
            "itc"
        ]
    },
    {
        url: "sparkle",
        title: "Sparkle",
        description: [
            "Știm că produsele complexe au nevoie de un design minimal, care să scoată în evidență fiecare detaliu. De aceea, am creat Sparkle, un design care așează produsele tale în lumina reflectoarelor.",
            "Sparkle vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Interfață intuitivă și design minimal",
            "Ideal pentru Produse Fashion, Accesorii",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro22b/",
        images: [
            "sparkle/thumb.jpg",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "joy",
        title: "Joy",
        description: [
            "Fiecare detaliu al magazinului tău online va surprinde vizitatorii în cele mai plăcute moduri. Indiferent de produsele pe care le comercializezi, fie că acestea sunt articole vestimentare, jucării sau accesorii pentru copii&bebe, clienții tăi se vor bucura de aceleași performanțe, de fiecare dată.",
            "Joy vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design dinamic și atractiv",
            "Ideal pentru Produse Copii & Bebe, Fashion",
        ],
        demoUrl: "https://s4s.blugento.ro/cbro17a/",
        images: [
            "joy/thumb.jpg",
        ],
        categories: [
            "kids",
            "fashion"
        ]
    },
    {
        url: "camino",
        title: "Camino",
        description: [
            "Camino este un design care excelează prin simplitate și detalii care îi conferă o eleganță aparte. Structura dinamică a designului îți permite să oferi o prezentare amplă a produselor.",
            "Camino vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de comparare produse.",
        ],
        bullets: [
            "Design elegant și atractiv",
            "Ideal pentru Produse Home & Deco",
        ],
        demoUrl: "https://s4s.blugento.ro/hdro19a/",
        images: [
            "camino/thumb.jpg",
        ],
        categories: [
            "homedeco"
        ]
    },
    {
        url: "zen",
        title: "Zen",
        description: [
            "Farmecul produselor de îngrijire a stat dintotdeauna în detaliile fine. Cu ajutorul designerilor noștri am conceput un design care să îți permită să personalizezi imaginea magazinului tău online în funcție de produsele pe care le comercializezi și să oferi experiențe personalizate vizitatorilor magazinului tău online.",
            "Zen vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul Review Produse.",
        ],
        bullets: [
            "Design fresh, aerisit",
            "Ideal pentru Produse sau Servicii Cosmetice, Produse Naturiste",
        ],
        demoUrl: "https://s4s.blugento.ro/csro28a/",
        images: [
            "zen/thumb.jpg",
        ],
        categories: [
            "cosmetics"
        ]
    },
    {
        url: "vitality",
        title: "Vitality",
        description: [
            "Am conceput un magazin online care sa pună produsele tale în lumina reflectoarelor. Designul modern și energic, nu impune limitări atunci când vine vorba de creativitate, iar tu poți personaliza interfața magazinului în funcție de valorile și mesajul brandului tău.",
            "Vitality vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse și Blog.",
        ],
        bullets: [
            "Interfață intuitivă și design minimal",
            "Ideal pentru Produse Outdoor, Sport, Fashion",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro24a/",
        images: [
            "vitality/thumb.jpg",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "home",
        title: "Home",
        description: [
            "Eleganța și simplitatea sunt elementele definitorii ale acestui design. Imaginile de calitate și designul intuitiv transformă experiența cumpărăturilor online într-o experiență vizuală unică.",
            "Home vine echipat din start cu Formular de abonare la newsletter și Modul de review produse si Wishlist.",
        ],
        bullets: [
            "Design elegant și atractiv",
            "Ideal pentru Produse Home & Deco, Industrii Creative",
        ],
        demoUrl: "https://s4s.blugento.ro/hdro33a/",
        images: [
            "home/thumb.jpg",
        ],
        categories: [
            "homedeco"
        ]
    },
    {
        url: "expert",
        title: "Expert",
        description: [
            "Știm cât de important este ca designul magazinului tău online să fie unul dinamic, ușor de personalizat. Interfața intuitivă gândită în detaliu de specialiștii noștri în design se adaptează în doar câțiva pași simpli la detaliile vizuale ale brandului tău.",
            "Expert vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Interfață intuitivă și design dinamic",
            "Ideal pentru Scule, Unelte și Echipamente",
        ],
        demoUrl: "https://s4s.blugento.ro/tero25a/",
        images: [
            "expert/thumb.jpg",
        ],
        categories: [
            "tools"
        ]
    },
    {
        url: "clasic",
        title: "Clasic",
        description: [
            "Prin eleganță și simplitate, designul Clasic scoate în evidență calitatea produselor tale, eliminând orice tip de distragere. Imaginile de calitate și designul intuitiv încurajează vizitatorii să petreacă timp în magazinul tău online și să se bucure de experiența cumpărăturilor online. Designul Clasic, denotă încredere și calitate.",
            "Clasic vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design elegant și atractiv",
            "Ideal pentru Produse Food & Drinks, Fashion, Beauty",
        ],
        demoUrl: "https://s4s.blugento.ro/fdro08a/",
        images: [
            "clasic/thumb.jpg",
        ],
        categories: [
            "fooddrinks"
        ]
    },
    {
        url: "biosens",
        title: "Biosens",
        description: [
            "Lasă-ți clienți cuceriți de povestea brandului tău. Biosens este conceput atât pentru companiile mici cât și cele mari, iar designul atractiv devine elementul complementar al brandului tău.",
            "Biosens vine echipat din start cu Wishlist, Formular de abonare la newsletter, Zoom pe imagini, Modul de review produse.",
        ],
        bullets: [
            "Design minimalist, fresh",
            "Ideal pentru Produse Cosmetice, Farmaceutice, Naturiste",
        ],
        demoUrl: "https://s4s.blugento.ro/csro02a/",
        images: [
            "biosens/thumb.jpg",
        ],
        categories: [
            "cosmetics"
        ]
    },
    {
        url: "minimal",
        title: "Minimal",
        description: [
            "Designul caracterizat prin simplitate scoate în evidență cele mai importante elemente ale brandului tău. Minimal vine cu un design dinamic și o interfață a utilizatorului intuitivă, care se adaptează ușor oricărei industrii.",
        ],
        bullets: [
            "Design minimalist, adaptabil și ușor de modificat",
            "Ideal pentru Produse Cosmetice, Home & Deco, Accesorii, Bijuterii",
        ],
        demoUrl: "https://s4s.blugento.ro/csro04a/",
        images: [
            "minimal/thumb.jpg",
        ],
        categories: [
            "cosmetics"
        ]
    },
    {
        url: "fresh",
        title: "Fresh",
        description: [
            "Întâmpină-ți clienții cu o experiență vizuală complexă. Fiecare element al acestui design debordează energie, creând o experiență memorabilă pentru vizitatori.",
            "Fresh vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de comparare produse.",
        ],
        bullets: [
            "Design intuitiv",
            "Ideal pentru Produse Food & Drinks, Bio & Eco",
        ],
        demoUrl: "https://s4s.blugento.ro/fdro18a/",
        images: [
            "fresh/thumb.jpg",
        ],
        categories: [
            "fooddrinks"
        ]
    },
    {
        url: "ocean",
        title: "Ocean",
        description: [
            "Farmecul produselor de îngrijire a stat dintotdeauna în detaliile fine. Cu ajutorul designerilor noștri am conceput un design care sa îți permită să personalizezi imaginea magazinului tău online în funcție de produsele pe care le comercializezi și să oferi experiențe personalizate vizitatorilor magazinului tău online.",
            "Ocean vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de comparare produse.",
        ],
        bullets: [
            "Design minimalist, fresh",
            "Ideal pentru Produse Cosmetice, Farmaceutice, Naturiste",
        ],
        demoUrl: "https://s4s.blugento.ro/csro36a/",
        images: [
            "ocean/thumb.jpg",
        ],
        categories: [
            "cosmetics"
        ]
    },
    {
        url: "loft",
        title: "Loft",
        description: [
            "Am creat un design care să se plieze ușor identității tale vizuale. Designul dinamic și interfața intuitivă sunt elementele care particularizează acest magazin online.",
            "Loft echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de comparare produse și Modul review.",
        ],
        bullets: [
            "Design atractiv și intuitiv",
            "Ideal pentru Produse de Grădinărit, Bricolaj, Scule & Echipamente",
        ],
        demoUrl: "https://s4s.blugento.ro/hdro32a/",
        images: [
            "loft/thumb.jpg",
        ],
        categories: [
            "tools"
        ]
    },
    {
        url: "ludic",
        title: "Ludic",
        description: [
            "Fiecare element al acestui design debordează energie și pasiune, creând o experiență cât mai plăcută pentru vizitatori. Îndreaptă atenția vizitatorilor către cele mai noi promoții și produse cu designul Ludic.",
            "Ludic vine echipat din start cu Formular de abonare la newsletter, Zoom pe imagini, Wishlist.",
        ],
        bullets: [
            "Design potrivit pentru orice tip de industrie",
            "Ideal pentru Produse pentru copii, IT & Electro",
        ],
        demoUrl: "https://s4s.blugento.ro/bpro11a/",
        images: [
            "ludic/thumb.jpg",
        ],
        categories: [
            "itc",
            "kids"
        ]
    },
    {
        url: "speed",
        title: "Speed",
        description: [
            "Ideal pentru industria Automoto, magazinul tău vine echipat cu toate funcționalitățile de care ai nevoie pentru a-ți impresiona clienții încă de la prima vizită. Designul optimizat pentru orice dispozitiv, te aduce mai aproape de clienții tăi indiferent de ce device folosesc.",
            "Magazinul tău online vine echipat cu Wishlist și Formular de abonare la newsletter și Modul comparare produse.",
        ],
        bullets: [
            "Design intuitiv, axat pe experiența utilizatorului",
            "Ideal pentru Auto & Moto, Scule și Echipamente",
        ],
        demoUrl: "https://s4s.blugento.ro/amro27a/",
        images: [
            "speed/thumb.jpg",
        ],
        categories: [
            "auto"
        ]
    },
    {
        url: "haute",
        title: "Haute",
        description: [
            "Designul Haute vine cu un design aerisit, și obține echilibrul perfect între elementele de branding și designul implicit. Intuitiv și dinamic, Haute pune accent pe cel mai important aspect al oricărui magazin online: produsele.",
            "Haute vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse.",
        ],
        bullets: [
            "Design minimalist și intuitiv",
            "Ideal pentru Accesorii și Fashion",
        ],
        demoUrl: "https://s4s.blugento.ro/fsro14a/",
        images: [
            "haute/thumb.jpg",
        ],
        categories: [
            "fashion"
        ]
    },
    {
        url: "wave",
        title: "Wave",
        description: [
            "Wave este un design dinamic și adaptabil, ideal pentru game de produse cu un număr mare de caracteristici. Designul Wave a fost conceput pentru a ajuta vizitatorii să găsească ceea ce caută într-un mod cât mai rapid și plăcut.",
            "Wave vine echipat din start cu Wishlist, Formular de abonare la newsletter, Modul de review produse, Zoom pe imagini.",
        ],
        bullets: [
            "Design intuitiv, axat pe experiența utilizatorului",
            "Ideal pentru Auto & Moto, IT & Electro",
        ],
        demoUrl: "https://s4s.blugento.ro/amro10a/",
        images: [
            "wave/thumb.jpg",
        ],
        categories: [
            "auto"
        ]
    }
];

export default expressTemplates;